import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/comments';
// const REST_API_BASE_URL = '/api';

export const getAllComments = () => {
    return axiosInstance.get(REST_API_BASE_URL);
};

export const createComment = (comment) => {
    return axiosInstance.post(REST_API_BASE_URL, comment);
};

export const getCommentsByCoordinatorEmail = (coordinatorEmail) => {
    return axiosInstance.get(`${REST_API_BASE_URL}/by-coordinator-email`, {
        params: { coordinatorEmail }
    });
};

export const getCommentsByProgressId = (progressId) => {
    return axiosInstance.get(`${REST_API_BASE_URL}/by-progress-id`, {
        params: { progressId }
    });
};

export const getCommentsByCommentedDate = (commentedDate) => {
    return axiosInstance.get(`${REST_API_BASE_URL}/by-commented-date`, {
        params: { commentedDate }
    });
};

export const getTotalCommentCount = () => {
    return axiosInstance.get(`${REST_API_BASE_URL}/count`);
};
